import { navigationPaneLabel } from './MailModule.locstring.json';
import loc from 'owa-localize';
/* tslint:disable:jsx-no-lambda WI:47690 */
import * as React from 'react';
import * as undoActions from 'owa-mail-undo';
import App from 'owa-application/lib/components/App';
import checkAndCreateNewMessage from 'owa-mail-message-actions/lib/actions/checkAndCreateNewMessage';
import createDropViewState from 'owa-dnd/lib/utils/createDropViewState';
import Droppable from 'owa-dnd/lib/components/Droppable';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import FolderPaneExpansionSource from 'owa-mail-store/lib/store/schema/FolderPaneExpansionSource';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import GroupCommandBarView from './GroupCommandBarView';
import groupHeaderCommandBarStore from 'owa-group-header-store/lib/store/CommandBarStore';
import GroupHeaderNavigationButton from 'owa-group-header-store/lib/store/schema/NavigationButton';
import GroupView from './GroupView';
import Header from 'owa-header/lib/components/Header';
import LeftRail, { HamburgerButton, isLeftRailVisible } from 'owa-left-rail';
import MailCommandBarView from './MailCommandBarView';

import MailView from './MailView';
import ModuleSwitcher, { Module } from 'owa-module-switcher';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import setFolderPaneWidth from 'owa-mail-module-actions/lib/actions/setFolderPaneWidth';
import setTypeOfItemBeingDragged from 'owa-mail-store/lib/actions/setTypeOfItemBeingDragged';
import store from 'owa-mail-store/lib/store/Store';
import { AdsPanelStub } from 'owa-mail-ads-stub';
import { lazyOpenCompose } from 'owa-mail-compose-store';
import { DragData } from 'owa-dnd/lib/utils/dragDataUtil';
import { exitSearch, SearchScenarioId } from 'owa-search';
import { FolderPane } from 'owa-mail-folder-forest-view';
import { getActiveContentTab } from 'owa-tab-store';
import { getCommands } from 'owa-mail-hotkeys';
import { getListViewDimensions } from 'owa-mail-list-dimensions';
import { getOwaUrlWithAddedQueryParameters } from 'owa-url';
import { getSelectedGroupId, isGroupSelected, lazyIsPrivateUnjoinedGroup } from 'owa-group-utils';
import { ImmersiveReaderContainer } from 'owa-immersive-reader';
import { isAnySxSDisplayed } from 'owa-sxs-store';
import { isAppPaneUnderlayExpanded } from 'owa-application';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { IsChildConsumerUser, IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
import { isDumpsterSearchTable } from 'owa-mail-list-search';
import { isDumpsterTable, listViewStore, SelectionDirection } from 'owa-mail-list-store';
import { IsGroupsEnabled } from 'owa-group-feature-flags';
import { isFeatureEnabled } from 'owa-feature-flags';
import { keydownHandler, addGlobalHotkey } from 'owa-hotkeys';
import { lazySubscribeToResizeEvent, lazyUnsubscribeFromResizeEvent } from 'owa-resize-event';
import { lazyTriggerResizeEvent } from 'owa-resize-event';
import { LeftnavUpsell } from 'owa-mail-leftnavupsell';
import { LightningId } from 'owa-lightning-v2';
import { MailQuickSwitcherEntrypoint } from 'owa-mail-quick-switcher';
import MailSearchBoxContainer from 'owa-mail-search/lib/components/MailSearchBoxContainer';
import { observer } from 'mobx-react';
import { OwaSuiteHeader } from 'owa-suite-header';
import { parse } from 'querystring';
import { PremiumDomainConnectFirstStepLightable } from 'owa-domain-connect';
import { resetFocus } from 'owa-mail-focus-manager';
import { ResizeHandle } from 'owa-resize-handle';
import { selectDefaultFolder } from 'owa-mail-folder-forest-actions';
import { selectFolder } from 'owa-mail-folder-forest-actions';
import { setShowFolderPane } from 'owa-mail-module-actions';
import { trace } from 'owa-trace';
import mailStore from 'owa-mail-store/lib/store/Store';
import getSelectedTableView from 'owa-mail-list-store/lib/utils/getSelectedTableView';
import { selectRowInDirection } from 'owa-mail-actions';
import {
    getFolderListWidth,
    getLeftNavWidth,
    getSearchBoxLeftPadding,
    lazyToggleFolderPaneExpansion,
    MIN_NAVIGATION_BAR_WIDTH,
    MAX_NAVIGATION_BAR_WIDTH,
} from 'owa-mail-module-actions';
import MailListItemSelectionSource from 'owa-mail-store/lib/store/schema/MailListItemSelectionSource';
import { PrivateDistributionlistModalEditor } from 'owa-favorite-pdl-editor';
import { getSelectedPublicFolderId, isPublicFolderSelected } from 'owa-publicfolder-utils';
import { setDraggedItemType as setDraggedItemTypeInModule } from 'owa-module-dnd-store';
import { globalStyles } from 'owa-global-styles';
import { lazyOnNavigateAwayViaUpDown } from 'owa-mail-mark-read-actions';
import { showO365ShellHeader } from 'owa-suite-header-apis';
import NewMessageButton from 'owa-mail-commandbar/lib/components/NewMessageButton';
import { SkipLinkPlaceholder } from 'owa-skip-link';
import { MailModuleDiagnosticsPanel } from 'owa-mail-diagnostics';
import { DiagnosticsPane } from 'owa-header-pane';

const styles = require('./MailModule.scss');
const classNames = require('classnames/bind').bind(styles);

// Replace this with an interface when we have real props
// For now leaving it as named so that the generic DragDropContext
// has a named type to use
export type MailModuleProps = {};
const DRAG_HINT_CHECK_PERIOD_IN_MILLISECONDS = 3000;
let hotkeyDisposeFunctions: (Promise<() => void>)[] = [];

@observer
export default class MailModule extends React.Component<MailModuleProps, {}> {
    private searchBoxRef: MailSearchBoxContainer;

    // Sometimes the browser has a bug which doesn't send the dragLeave event when the drag is over.
    // So we need to repeatedly check whether to remove the drag hint after a certain time
    // before we receive dragLeave/drop event.
    private pendingDragHintRemover;
    private lastDragOverTime;

    componentDidMount() {
        // Set initial focus after component is mounted
        resetFocus();

        lazySubscribeToResizeEvent.importAndExecute(() =>
            setShowFolderPane(FolderPaneExpansionSource.WindowResize)
        );

        this.initializeMailHotKeys();
    }

    componentWillUnmount() {
        lazyUnsubscribeFromResizeEvent.importAndExecute(() =>
            setShowFolderPane(FolderPaneExpansionSource.WindowResize)
        );

        this.disposeMailHotKeys;
    }

    // default options are: preventDefault: true, stopPropagation: true, allowHotkeyOnTextFields: false
    private initializeMailHotKeys() {
        hotkeyDisposeFunctions.push(
            addGlobalHotkey(getCommands().newMail, this.newMessage, { preventDefault: false }),
            addGlobalHotkey(getCommands().gotoMail, this.gotoMail),
            addGlobalHotkey(getCommands().gotoCalendar, this.gotoCalendar),
            addGlobalHotkey(getCommands().gotoPeople, this.gotoPeople),
            addGlobalHotkey(getCommands().gotoTasks, this.gotoTasks),
            addGlobalHotkey(getCommands().gotoInbox, this.gotoInbox),
            addGlobalHotkey(getCommands().gotoDrafts, this.gotoDrafts),
            addGlobalHotkey(getCommands().gotoSent, this.gotoSentItems),
            addGlobalHotkey(getCommands().gotoSearch, this.gotoSearch)
        );
    }

    private disposeMailHotKeys() {
        hotkeyDisposeFunctions.forEach(disposalFunctionPromise => {
            disposalFunctionPromise.then(disposalFunction => disposalFunction());
        });
        hotkeyDisposeFunctions = [];
    }

    private showGroupView(): boolean {
        return IsGroupsEnabled() && isGroupSelected();
    }

    private showPublicFolderView(): boolean {
        return isPublicFolderSelected() && isFeatureEnabled('pf-post');
    }

    private saveSearchRef = ref => (this.searchBoxRef = ref);

    renderRightPane(): JSX.Element {
        const userConfiguration = getUserConfiguration();
        const tableQuery = listViewStore.tableViews.get(listViewStore.selectedTableViewId)
            .tableQuery;
        const isDumpsterOrDumpsterSearchTable =
            isDumpsterTable(tableQuery) || isDumpsterSearchTable(tableQuery);
        const readingPanePosition = userConfiguration.UserOptions.GlobalReadingPanePositionReact;
        const activeTab = getActiveContentTab();
        const listViewDimensions = getListViewDimensions();

        const commonMailViewProps = {
            activeTab,
            isDumpsterOrDumpsterSearchTable,
            listViewDimensions,
            readingPanePosition,
        };

        const isInGroupView = this.showGroupView();
        return (
            <div className={styles.rightPane}>
                {isInGroupView ? (
                    <>
                        <GroupCommandBarView {...commonMailViewProps} />
                        <GroupView {...commonMailViewProps} />
                    </>
                ) : (
                    <>
                        <MailCommandBarView {...commonMailViewProps} />
                        <MailView {...commonMailViewProps} />
                    </>
                )}
            </div>
        );
    }

    renderSearch = () => {
        return (
            !this.isSearchHidden() && (
                <MailSearchBoxContainer
                    isDisabled={this.isSearchDisabled()}
                    ref={this.saveSearchRef}
                />
            )
        );
    };

    renderHeader = () => {
        return showO365ShellHeader() ? (
            <OwaSuiteHeader
                searchAlignmentWidth={getSearchBoxLeftPadding()}
                renderSearch={this.renderSearch}
                DiagnosticsPanel={
                    isFeatureEnabled('fwk-betterDiagnostics-panel')
                        ? MailModuleDiagnosticsPanel
                        : DiagnosticsPane
                }
            />
        ) : (
            <Header headerLeftSectionStyle={{ maxWidth: getSearchBoxLeftPadding() }}>
                {!this.isSearchHidden() && (
                    <MailSearchBoxContainer
                        isDisabled={this.isSearchDisabled()}
                        ref={this.saveSearchRef}
                    />
                )}
            </Header>
        );
    };

    renderSkipLinkPlaceholder = () => {
        return <SkipLinkPlaceholder />;
    };

    render() {
        const isPaneExpanded = store.mailModule.showFolderPane;
        const emptyDropViewState = createDropViewState();
        const leftNavWidth = getLeftNavWidth();
        const leftPaneClasses = classNames(styles.leftPane, globalStyles.addFocusOutline);
        return (
            <App
                renderHeader={this.renderHeader}
                renderSkipLinkPlaceholder={this.renderSkipLinkPlaceholder}>
                {isFeatureEnabled('cmp-quickSwitcher') ? <MailQuickSwitcherEntrypoint /> : null}
                <Droppable
                    classNames={styles.mailMain}
                    onDrop={this.onDrop}
                    onDragOver={this.onDragOver}
                    onDragLeave={this.onDragLeave}
                    dropViewState={emptyDropViewState}
                    shouldIgnoreTransientOnDragLeave={true}
                    bypassActOnDrop={true}>
                    <div
                        className={classNames(
                            styles.paneContainer,
                            isFeatureEnabled('fwk-fluentCommandBar') && styles.fluent
                        )}>
                        <div
                            tabIndex={-1}
                            role={'region'}
                            aria-label={loc(navigationPaneLabel)}
                            className={leftPaneClasses}
                            style={{ width: leftNavWidth }}
                            data-min-width={MIN_NAVIGATION_BAR_WIDTH}
                            data-max-width={MAX_NAVIGATION_BAR_WIDTH}>
                            {this.renderNewMessageButton()}
                            <div className={styles.leftPanelSecondRow}>
                                {(!isPaneExpanded || isLeftRailVisible()) && (
                                    <LeftRail
                                        selectedModule={Module.Mail}
                                        activeModuleAction={selectDefaultFolder}
                                    />
                                )}
                                {isPaneExpanded && (
                                    <div
                                        className={styles.leftColumn}
                                        style={{ width: getFolderListWidth() }}>
                                        <FolderPane />
                                        {this.ShowLeftNavPremiumUpsell() && <LeftnavUpsell />}
                                        {!isLeftRailVisible() && (
                                            <ModuleSwitcher
                                                selectedModule={Module.Mail}
                                                activeModuleAction={selectDefaultFolder}
                                                isHorizontal={true}
                                                containerWidth={leftNavWidth}
                                            />
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                        <ResizeHandle
                            className={styles.paddingTop}
                            onResize={this.leftNavResizeHandler}
                        />
                        {this.renderRightPane()}
                        {isConsumer() && isFeatureEnabled('fwk-ads') && (
                            <AdsPanelStub isBottom={false} isHidden={isAppPaneUnderlayExpanded()} />
                        )}
                    </div>
                    {isConsumer() && isFeatureEnabled('fwk-ads') && (
                        <AdsPanelStub isBottom={true} />
                    )}
                </Droppable>
                {isFeatureEnabled('rp-immersiveReader') && <ImmersiveReaderContainer />}
                {isFeatureEnabled('peo-favoritePdls') && <PrivateDistributionlistModalEditor />}
                {this.ShowDomainConnectFirstStep() && (
                    <PremiumDomainConnectFirstStepLightable
                        lid={LightningId.PremiumDomainConnectModal}
                        when={lightup => lightup()}
                    />
                )}
            </App>
        );
    }

    private renderNewMessageButton(): JSX.Element {
        const isPaneExpanded = store.mailModule.showFolderPane;
        const isInGroupView = this.showGroupView();
        const currentView = groupHeaderCommandBarStore.navigationButtonSelected;
        const inGroupFiles = isInGroupView && currentView == GroupHeaderNavigationButton.Files;

        return (
            <div className={styles.leftPanelFirstRow}>
                <HamburgerButton
                    isPaneExpanded={isPaneExpanded}
                    toggleHamburgerButton={this.toggleFolderPaneExpansion}
                />
                {isPaneExpanded && (
                    <div className={styles.newMessageButtonWrapper}>
                        {inGroupFiles ? null : (
                            <NewMessageButton
                                scenario={this.showPublicFolderView() ? 'publicFolder' : 'default'}
                                onClick={this.onNewMessageButtonClicked}
                                onMouseOver={this.backgroundLoadCompose}
                            />
                        )}
                    </div>
                )}
            </div>
        );
    }

    private backgroundLoadCompose = () => lazyOpenCompose.import();

    private onNewMessageButtonClicked = () => {
        if (!isAnySxSDisplayed()) {
            const targetId: string = this.showPublicFolderView()
                ? getSelectedPublicFolderId()
                : !isFeatureEnabled('grp-groupHeaderV2')
                ? getSelectedGroupId()
                : null;
            checkAndCreateNewMessage('CommandBar', targetId);
        }
    };

    private toggleFolderPaneExpansion = () => {
        lazyToggleFolderPaneExpansion.importAndExecute();
    };

    private isPrivateUnjoinedGroup = () => {
        if (isGroupSelected()) {
            const isPrivateUnjoinedGroup = lazyIsPrivateUnjoinedGroup.tryImportForRender();
            if (isPrivateUnjoinedGroup) {
                return isPrivateUnjoinedGroup(getSelectedGroupId());
            }
        }
        return false;
    };

    // VSO Bug 18257: preventDefault needs to be false
    // in order to let the keypress go to the password box of the PDF viewer in Chrome
    private newMessage = () => {
        // do nothing if SxS is showing
        if (!isAnySxSDisplayed()) {
            if (this.showPublicFolderView()) {
                checkAndCreateNewMessage('Keyboard', getSelectedPublicFolderId());
            } else {
                checkAndCreateNewMessage('Keyboard', getSelectedGroupId());
            }
        }
    };

    @keydownHandler(getCommands().undoAction)
    undoAction() {
        // do nothing if SxS is showing
        if (!isAnySxSDisplayed()) {
            undoActions.lazyUndo.importAndExecute('Keyboard');
        }
    }

    @keydownHandler('esc', false /* stopPropagation */)
    onEscape(evt: KeyboardEvent) {
        // If we are showing immersive reading pane this will only be called if focus was not on RP.
        // If focus was on RP then it will close the immersive RP.
        // MailModule should not close the immersive RP on key press as it is tied to different keys depending on a keyset and not just 'esc'.
        const readingPanePosition = getUserConfiguration().UserOptions
            .GlobalReadingPanePositionReact;
        const isImmersiveReadingPaneShown =
            readingPanePosition == ReadingPanePosition.Off && store.mailModule.showReadingPane;
        if (!isImmersiveReadingPaneShown && this.searchBoxRef) {
            // Search box is hidden in groups and when preview pane is shown
            exitSearch('Keyboard', SearchScenarioId.Mail);
        }
    }

    private gotoMail = () => {
        window.location.assign(getOwaUrlWithAddedQueryParameters({ path: '/mail' }));
    };

    private gotoCalendar = () => {
        window.location.assign(getOwaUrlWithAddedQueryParameters({ path: '/calendar' }));
    };

    private gotoPeople = () => {
        window.location.assign(getOwaUrlWithAddedQueryParameters({ path: '/people' }));
    };

    private gotoTasks = () => {
        window.location.assign(getOwaUrlWithAddedQueryParameters({ path: '/tasks' }));
    };

    private gotoInbox = () => {
        const inboxId = folderNameToId('inbox');
        selectFolder(inboxId, 'primaryFolderTree', 'Keyboard' /* actionSource */);
    };

    private gotoDrafts = () => {
        const draftsId = folderNameToId('drafts');
        selectFolder(draftsId, 'primaryFolderTree', 'Keyboard' /* actionSource */);
    };

    gotoSentItems() {
        const sentitemsId = folderNameToId('sentitems');
        selectFolder(sentitemsId, 'primaryFolderTree', 'Keyboard' /* actionSource */);
    }

    private gotoSearch = () => {
        this.searchBoxRef.setFocus();
    };

    @keydownHandler(getCommands().openNextItem)
    selectNextRowShortcut() {
        this.selectNextPreviousInternal(SelectionDirection.Next);
    }

    @keydownHandler(getCommands().openPrevItem)
    selectPreviousRowShortcut() {
        this.selectNextPreviousInternal(SelectionDirection.Previous);
    }

    private selectNextPreviousInternal = (selectionDirection: SelectionDirection) => {
        const tableView = getSelectedTableView();
        const selectedRows = tableView.selectedRowKeys;

        // Select the previous item in immersive mode
        if (!mailStore.mailModule.showListPane && selectedRows.size > 0) {
            lazyOnNavigateAwayViaUpDown.importAndExecute([...selectedRows.keys()][0], tableView);
            selectRowInDirection(
                tableView,
                selectionDirection,
                MailListItemSelectionSource.CommandBarArrows
            );
        } else {
            selectRowInDirection(
                tableView,
                selectionDirection,
                MailListItemSelectionSource.KeyboardUpDown
            );
        }
    };

    /**
     * An onResize callback used to update the user config with the new value for folder list's width.
     * This is the same value used in jsMVVM for the whole folder pane. We need to adjust the value slightly
     * to reflect the presense of left rail.
     * @param fullLeftNavWidth - the measured width from the left of the screen to the resize handle
     */
    private leftNavResizeHandler(fullLeftNavWidth: number): void {
        setFolderPaneWidth(fullLeftNavWidth, FolderPaneExpansionSource.LeftNavResizeExpand);
        lazyTriggerResizeEvent.importAndExecute();
    }

    private onDragLeave = () => {
        trace.info('onDragLeave');
        this.setDataItemType(null);
        this.clearPendingDragHintRemover();
    };

    private onDragOver = (dragInfo: DragData) => {
        this.lastDragOverTime = Date.now();
        if (!this.pendingDragHintRemover) {
            this.pendingDragHintRemover = setInterval(() => {
                trace.info('Check last DragOver time');
                // If we haven't received any dragOver event within the period, let's hide the drag hint.
                if (Date.now() - this.lastDragOverTime >= DRAG_HINT_CHECK_PERIOD_IN_MILLISECONDS) {
                    this.setDataItemType(null);
                    this.clearPendingDragHintRemover();
                }
            }, DRAG_HINT_CHECK_PERIOD_IN_MILLISECONDS);
        }

        this.setDataItemType(dragInfo.itemType);
    };

    private onDrop = (dragData: any) => {
        this.setDataItemType(null);
        this.clearPendingDragHintRemover();
    };

    private clearPendingDragHintRemover() {
        trace.info('clearPendingDragHintRemover');
        if (this.pendingDragHintRemover) {
            clearInterval(this.pendingDragHintRemover);
            this.pendingDragHintRemover = null;
        }
    }

    private setDataItemType(newValue: string) {
        if (store.typeOfItemBeingDragged != newValue) {
            setTypeOfItemBeingDragged(newValue);
            setDraggedItemTypeInModule(newValue);
        }
    }

    /**
     * Search box is hidden when
     * 1. The preview pane (SxS V1) is opened
     */
    private isSearchHidden(): boolean {
        /**
         * This flight represents SxS's new modal UX. In this experience, the
         * user cannot interact with search while in SxS, so there's no need
         * to hide it. So if this flight is on, just return false.
         */
        if (isFeatureEnabled('doc-SxS-V2')) {
            return false;
        }

        return isAnySxSDisplayed();
    }

    private isSearchDisabled(): boolean {
        return this.isPrivateUnjoinedGroup();
    }

    private ShowLeftNavPremiumUpsell(): boolean {
        return (
            !IsShadowMailboxUser() &&
            isFeatureEnabled('auth-leftNavPremiumUpsell') &&
            !IsChildConsumerUser() &&
            getUserConfiguration().SessionSettings.UserCulture.indexOf('jp') == -1
        );
    }

    private ShowDomainConnectFirstStep(): boolean {
        const queryStringStartIndex = window.location.href.indexOf('?');
        const queryString =
            queryStringStartIndex !== -1
                ? window.location.href.slice(queryStringStartIndex + 1)
                : '';
        const queryStringValues = parse(queryString);

        // The test hook query string parameter has the domain name
        const testHook = queryStringValues.testhook;

        return (
            isFeatureEnabled('auth-domainConnectDemandGen') &&
            (testHook != null ||
                (getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox &&
                    (getUserConfiguration().SessionSettings.PremiumAccountOffers & 2) != 2 &&
                    !getUserConfiguration().SessionSettings.IsProsumerConsumerMailbox))
        );
    }
}
